<template>
    <div>
        <div class="modal hide fade" id="modalProductCostSync" tabindex="-1" role="dialog" aria-labelledby="modalProductCostList" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Sync COGS</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label for="cost_date" class="col-sm-3 col-form-label text-left">Sync Date</label>
                                    <div class="col-sm-3">
                                        <datetime v-model="cost_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="company_no" class="col-sm-3 col-form-label text-left">Company Date</label>
                                    <div class="col-sm-3">
                                        <select v-model="company_no" class="form-control">
                                            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-hard-primary" data-dismiss="modal" >Cancel</button>
                        <button type="button" class="btn btn-soft-primary" data-dismiss="modal" @click="process">Process</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ProductListModal',
  data () {
    return {
      cost_date: null,
      company_no: null
    }
  },
  computed: {
    ...mapState({
      companyList: state => state.companies.companyList
    })
  },
  methods: {
    process () {
      var obj = {
        date: this.cost_date,
        company_no: this.company_no
      }
      this.$emit('getSyncData', obj)
    }
  }
}
</script>
